import { useState, createContext, useEffect, useContext } from "react";

import { authenticateAdmin, authorizeAdmin, logoutAdmin } from "./authentication.services";
import { getItem, removeItem, saveItem } from "../../_helpers/localstorage";

export const AuthenticationContext = createContext();

export const AuthenticationContextProvider = ({ children }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState();
    const [admin, setAdmin] = useState();
    const [token, setToken] = useState('');

    /** authenticate admin */
    const authenticate = async (email, password) => {
        try {
            setIsLoading(true);
            const response = await authenticateAdmin(email, password);
            const res = await response.json();
            if (res?.error) {
                setIsAuthenticated(false);
                console.log(res);
                setIsLoading(false);
                return res;
            }
            if (res?.token) {
                saveItem('token', res?.token);
                setIsAuthenticated(true);
                setToken(res?.token);
                setIsLoading(false);
                window.location.href = `/auth_redirect?token=${encodeURIComponent(res?.token)}`;
            }

            return res;
        } catch (error) {
            console.log({ error });
            setIsLoading(false);
        }
    }

    /** logout */
    const adminLogout = async (token) => {
        try {
            setIsLoading(true);
            const response = await logoutAdmin(token);
            const res = await response.json();
            console.log(res);
            if (res?.error) {
                setIsLoading(false);
                return res;
            }
            setIsAuthenticated(false);
            removeItem('token');
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log({ error });
        }
    }

    useEffect(() => {
        const Controller = new AbortController();
        const getAdminData = async (token) => {
            try {

                setIsAuthenticated(true);
                const response = await authorizeAdmin(token);
                const res = await response.json();
                console.log(res);
                return res;
            } catch (error) {
                console.log({ error: 'Unauthorized4!'})
            }
        }
        (async () => {
            try {
                const t = await getItem('token');
                console.log({ token: t });
                if (t?.error) {
                    return;
                };
                const data = await getAdminData(t);
                if (data?.error) {
                    setIsAuthenticated(false);
                    console.log({ data, token: t });
                    return;
                }
                setAdmin(data);
                setToken(t);
                setIsAuthenticated(true);
            } catch (e) {
                console.log(e);
                setIsAuthenticated(false);
            }
        })();
        //console.log({isAuthenticated});
        return () => Controller.abort();
    }, [])

    return (
        <AuthenticationContext.Provider
            value={{
                isLoading,
                isAuthenticated,
                admin,
                token,
                authenticate,
                adminLogout
            }}
        >
            {children}
        </AuthenticationContext.Provider>
    );
}

export const useAuthentication = () => useContext(AuthenticationContext);